<template>
  <div>
    <el-form :model="form" :inline="true">
      <el-row>
        <el-col :span="6">
          <el-form-item label="患儿姓名" prop="childName">
            <el-input type="text" v-model="form.searchCond.childName" size="small" placeholder="请输入" />
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="申请编号" prop="helpId">
            <el-input type="text" v-model="form.searchCond.helpId" size="small" placeholder="请输入" />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <SearchButton @search="queryList" @reset="reset" @expand="e => expand = e"></SearchButton>
        </el-col>
      </el-row>
      <el-row v-if="expand">
        <el-col :span="6">
          <el-form-item label="病种大类" prop="initialProject">
            <el-select v-model="form.searchCond.initialProject" size="small" placeholder="请选择" clearable>
              <el-option label="先天性心脏病" value="AY1001"></el-option>
              <el-option label="血液及肿瘤疾病" value="AY1002"></el-option>
              <el-option label="出生缺陷及其他疾病" value="AY1003"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :md="6">
          <el-form-item label="病种">
            <DiseaseCascader
              v-model="form.searchCond.diseasesId"
              :hospitalId="form.searchCond.hospitalId"
              :all="true"
              :multiple="false">
            </DiseaseCascader>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="申请时间" prop="helpQuota">
            <DateRangePicker v-model="form.searchCond.requestTimeRange">
            </DateRangePicker>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="申请方式" prop="searchCond.reqMode">
            <el-select v-model="form.searchCond.reqMode" size="small" placeholder="请选择" clearable>
              <el-option label="家长申请" :value="1"></el-option>
              <el-option label="代申请" :value="2"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="救助状态" prop="searchCond.apprStatus">
            <DictionarySelect v-model="form.searchCond.apprStatus" tableCode="APPROVE_STATUS" :lazy="true" :excludeKeys="['5']">
            </DictionarySelect>
          </el-form-item>
        </el-col>
        <el-col :md="6">
          <el-form-item label="审核时间" prop="apprTimeRange">
            <DateRangePicker v-model="form.searchCond.apprTimeRange"></DateRangePicker>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="费用状态" prop="searchCond.outlayStatus">
            <DictionarySelect v-model="form.searchCond.outlayStatus" tableCode="OUTLAY_STATE" :lazy="true">
            </DictionarySelect>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="协议编号" prop="protocolId">
            <el-input type="text" v-model="form.searchCond.protocolId" size="small" placeholder="请输入" />
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="协议状态" prop="searchCond.protocolStatus">
            <DictionarySelect v-model="form.searchCond.protocolStatus" tableCode="PROTOCOL_PROGRESS" :lazy="true">
            </DictionarySelect>
          </el-form-item>
        </el-col>
<!--        <el-col v-if="!isHospitalRole" :span="6">
          <el-form-item label="救助医院" prop="hospitalId">
            <HospitalSelect v-model="form.searchCond.hospitalId"></HospitalSelect>
          </el-form-item>
        </el-col>-->
      </el-row>
    </el-form>
  </div>

</template>

<script>
  import {
    getAYDictByTableCodeApi,
    getCMDictByTableCodeApi,
    getGrantedDiseasesTreeApi,
    getMyHospitalListApi
  } from "@/util/api";
  import SearchButton from "@/components/business/SearchButton";
  import HospitalSelect from "@/components/business/HospitalSelect";
  import DiseaseCascader from "@/components/business/DiseaseCascader";
  import DateRangePicker from "@/components/business/DateRangePicker";
  import LocationCascader from "@/components/business/LocationCascader";
  import DictionarySelect from "@/components/business/DictionarySelect";
  export default {
    components: {
      SearchButton,
      HospitalSelect,
      DateRangePicker,
      LocationCascader,
      DictionarySelect,
      DiseaseCascader
    },
    props: {
      apprStatus: null,
      queryForm: {},
    },
    data() {
      let isHospitalRole = this.isHospital();
      return {
        isHospitalRole: isHospitalRole,
        form: {},
        expand: false,
        MultiSelect: {
          value: "diseasesId",
          label: "diseasesName",
          children: "childDiseasesList"
        },
        hospitalOptions: [], //救助医院数据
        diseaseOptions: [],
        helpStatus: [], // 救助状态数据
        lazy: {
          lazy: true,
          lazyLoad: this.lazyLoad
        },
        outlay_state: [],
        valueParentId: '',
        level: 0,
        disease: '', //病种
        location: [], //户口所在地,
        protocol_progress: [],
      }
    },
    created() {
      this.form = this.queryForm
      this.getMyHospitalList()
      this.getCMDictByTableCode() //获取救助状态字典
      this.getCMDictByTableCodeXy() //获取救助状态字典
      this.getCMDictByTableCodeFy() //获取救助状态字典
    },
    methods: {
      queryList() {
        if (this.form.searchCond.requestTimeRange && this.form.searchCond.requestTimeRange.length > 1) {
          this.form.searchCond.requestTimeBegin = this.form.searchCond.requestTimeRange[0];
          this.form.searchCond.requestTimeEnd = this.form.searchCond.requestTimeRange[1].replace('00:00:00', '23:59:59');
        } else {
          this.form.searchCond.requestTimeBegin = null;
          this.form.searchCond.requestTimeEnd = null;
        }
        if (this.form.searchCond.apprTimeRange && this.form.searchCond.apprTimeRange.length > 1) {
          this.form.searchCond.apprTimeBegin = this.form.searchCond.apprTimeRange[0];
          this.form.searchCond.apprTimeEnd = this.form.searchCond.apprTimeRange[1].replace('00:00:00', '23:59:59');
        } else {
          this.form.searchCond.apprTimeBegin = null;
          this.form.searchCond.apprTimeEnd = null;
        }
        this.form.pageNO = 1
        this.$emit('query', this.form)
      },
      openScreenFun() {
        this.openScreen1 = !this.openScreen1
      },
      // 重置筛选项
      reset() {
        this.disease = ''
        this.location = []
        this.form.searchCond = {
          "childName": "", //患儿姓名
          "diseasesId": "", //病种
          "hospitalId": "", //救助医院
          "idNumber": "", //身份证号
          "province": "", //所在省
          "reqMode":"",
          "city": "", //所在市
          "county": "", //所在区县
          "requestTimeBegin": "", //申请时间（开始）
          "requestTimeEnd": "", //申请时间（结束）
          "apprStatus": "", //救助状态
          "apprTimeBegin": "", //审核时间（开始）
          "apprTimeEnd": "", //审核时间（结束）
          "outlayStatus": "", //费用状态
          "protocolStatus": "", //协议状态
          "isTimeout": "", //是否超期患儿
          "specialFlag": "", //特殊标记（1=公益宝贝，2=三区三州）
          "isSpecialPatient": "", //是否特患
        }
        this.queryList();
      },
      // 选择户口所在地
      handleChange(e) {
        this.form.searchCond.province = e[0]
        this.form.searchCond.city = e[1]
        this.form.searchCond.county = e[2]
      },

      // 懒加载城镇信息
      lazyLoad(node, resolve) {
        this.getDoorPlate(node, resolve)
      },
      // 懒加载城镇信息请求
      getDoorPlate(node, resolve) {
        this.level = node.level + 1
        if (node.data) {
          this.valueParentId = node.data.valueParentId
        } else {
          this.valueParentId = ""
        }
        try {
          let params = {
            valueParentId: this.valueParentId,
            tableCode: "city",
          }
          getAYDictByTableCodeApi(params).then(res => {
            if (Array.isArray(res.responseData)) {
              const nodes = res.responseData.map(item => ({
                value: item.valueCode, //
                label: item.valueName,
                leaf: node.level >= 2, // 3层级
                valueParentId: item.valueCode
              }))
              resolve(nodes)
            } else {
              this.$message.error(res.msg || res.error)
            }
          }).catch()

        } catch (e) {
          this.$message.error('请求失败')
        }
      },

      // 救助状态字典
      getCMDictByTableCode() {
        let params = {
          tableCode: "APPROVE_STATUS",
        }
        getCMDictByTableCodeApi(params).then(res => {
          if (res.msgCode == 200) {
            this.helpStatus = res.responseData
            for (var i = 0; i < this.helpStatus.length; i++) {
              if (this.helpStatus[i].valueCode == '1') this.helpStatus[i].valueCode = '1,5'
              if (this.helpStatus[i].valueCode == '5') this.helpStatus.splice(i, 1)
            }
          } else {
            this.$message.error(res.msg)
          }
        })
      },
      // 协议状态字典
      getCMDictByTableCodeXy() {
        let params = {
          tableCode: "PROTOCOL_PROGRESS",
        }
        getCMDictByTableCodeApi(params).then(res => {
          if (res.msgCode == 200) {
            this.protocol_progress = res.responseData
          } else {
            this.$message.error(res.msg)
          }
        })
      },
      // 协议状态字典
      getCMDictByTableCodeFy() {
        let params = {
          tableCode: "OUTLAY_STATE",
        }
        getCMDictByTableCodeApi(params).then(res => {
          if (res.msgCode == 200) {
            this.outlay_state = res.responseData
          } else {
            this.$message.error(res.msg)
          }
        })
      },
      // 选择病种
      changeDisease(e) {
        this.form.searchCond.diseasesId = e[2]
      },
      getHosp(e) {
        this.getGrantedDiseasesTree(e)
      },
      // 病种树状列表
      getGrantedDiseasesTree(id) {
        let params = {
          hospitalId: id
        }
        getGrantedDiseasesTreeApi(params).then(res => {
          if (res.msgCode == 200) {
            this.diseaseOptions = res.responseData
          } else {
            this.$message.error(res.msg)
          }
        }).catch()
      },

      // 获取医院管理伙伴列表
      getMyHospitalList() {
        getMyHospitalListApi().then(res => {
          if (res.msgCode == 200) {
            this.hospitalOptions = res.responseData
          } else {
            this.$message.error(res.msg)
          }
        }).catch()
      },
    }
  }
</script>

<style lang="scss" scoped>
  @import 'src/common/form';
  //@import "src/common/tableScreenCss";
</style>



// WEBPACK FOOTER //
// src/pages/child/manage/tableScreen.vue